<template>
  <popup
    v-model="visible"
    size="sm"
  >
    <slot>
      <div class="modal-title">
        {{ headers.title }}
      </div>
      <div class="modal-description">
        {{ headers.body }}
      </div>
      <div class="modal-buttons">
        <yt-button
          color="green"
          @click="openSupportChat"
        >
          {{ headers.btn }}
        </yt-button>
      </div>
    </slot>
  </popup>
</template>

<script>
import Popup from "@/components/ui-kit/yt-popup";
import YtButton from "@/components/ui-kit/yt-button";
import {mapState} from "vuex";

export default {
  components: {
    Popup,
    YtButton,
  },
  data() {
    return {
      headers: {
        title: this.$t('paymentRequisites.popupChangeRequisites.title'),
        body: this.$t('paymentRequisites.popupChangeRequisites.body'),
        btn: this.$t('paymentRequisites.popupChangeRequisites.btn'),
      },
      visible: false,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    chatLink() {
      return '/lk/im/support';
    },
  },
  methods: {
    openByEvent() {
      this.visible = true;
    },
    openSupportChat() {
      window.open(this.chatLink, '_blank');
      this.visible = false;
    },
  },
  mounted() {
    fakeWindow.addEventListener("popup.change-payment-requisites", this.openByEvent);
  },
  beforeDestroy() {
    fakeWindow.removeEventListener("popup.change-payment-requisites", this.openByEvent);
  }
}
</script>
